import { useReducer } from "react";
import logActions from "./logActions";
import logReducer from "./logReducer";


export default function useNotes() {
  const [log, logDispatch] = useReducer(logReducer, {});
  const { fetchLog, 
    fetchImportantLog, 
    fetchSupervisorLog, 
    write,  
    writeImportantLog, 
    writeSupervisorLog } = logActions(logDispatch);

  return {
    response: log,
    fetchLog,
    fetchImportantLog,
    fetchSupervisorLog,
    write,
    writeImportantLog,
    writeSupervisorLog
  };
}
